// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_k0m","cls2":"AuthorHeader-cls2_Wt7 AuthorHeader-cls1_k0m"};